import { default as Mui5FormHelperText } from '@mui/material/FormHelperText'

export const FormHelperText = Mui5FormHelperText
